import { useDispatch, useSelector } from "react-redux";
import { getCodePopup, getGiftsListPopup, getWinnersPopup, getGiftData, openConfirmSpinPopup } from "../redux/actions";
import { GiftsListPopup } from "../components/popups/GiftsListPopup";
import { CodePopup } from "../components/popups/CodePopup";
import { Wheel } from "../components/Wheel";
import { WinnersSlider } from "../components/sliders/winnersSlider/WinnersSlider";
import emptyWheel from "../images/empty-wheel.png"

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';
import { GameShopSlider } from "../components/gameShop/gameShopSlider/GameShopSlider";
import { WheelWinnersPopup } from "../components/popups/WheelWinnersPopup";
import { ShopWinnersPopup } from "../components/popups/ShopWinnersPopup";
import { useEffect, useState } from "react";

// import required modules


export const Games = () => {
    const dispatch = useDispatch()
    const id = useSelector(state => state.game.gameWheel.settings?.id)
    const code = useSelector(state => state.app.code)
    const showGifts = useSelector(state => state.game.gameWheel.settings?.showGifts)
    const showWinners = useSelector(state => state.game.gameWheel.settings?.showWinners)
    const giftsList = useSelector(state => state.game.gameWheel.gifts)
    const winners = useSelector(state => state.game.gameWheel.winners)
    const spinReady = useSelector(state => state.game.spinReady)
    const isMobile = useSelector(state => state.app.isMobile)
    const lang = useSelector(state => state.app.currentLang);
    const isSameTab = useSelector(state => state.game.gameShop.settings?.isSameTab);
    const shopStatus = useSelector(state => state.game.gameShop.settings?.status);
    const showLinkInGames = useSelector(state => state.user.showLinkInGames)
    const isLogin = useSelector((state) => state.user.isLogin);
    const hasActiveGame = useSelector(state => state.user.hasActiveGame)
    const playPrice = useSelector((state) => state.game.gameWheel.settings?.playPrice);
    const [bodyWidth, setBodyWidth] = useState(0);

    let canBeWonSomething = false
    const wheelAnimation = useSelector(state => state.game.wheelAnimation)
    if (Array.isArray(giftsList) && giftsList.length > 0) {
        for (let i = 0; i < giftsList.length; i++) {
            if (giftsList[i].canBeWon) {
                canBeWonSomething = true;
                break;
            }
        }
    }
    useEffect(() => {
        setBodyWidth(window.innerWidth);
        const handleResize = (event) => {
            setBodyWidth(event.target.innerWidth);
        };
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    let borderStype = "";
    if (isMobile) {
        borderStype = (bodyWidth / 2) + "px " + (bodyWidth / 2) + "px 50px 50px ";
    } else {
        borderStype = "170px 35px 35px 170px ";
    }
    function getGift(event) {
        event.preventDefault()
        if (!wheelAnimation) {
            dispatch(getGiftData(id, code))
        }
    }
    const mainButtonComponent =
        <div className="game__button_row">
            {
                spinReady
                    ? <button className="game__mainbutton ready" onClick={(event) => getGift(event)} >{lang.games1}</button>
                    : (isLogin && playPrice)
                        ? <button className="game__mainbutton" onClick={(event) => dispatch(openConfirmSpinPopup())} >{lang.games1+' '+playPrice}<div className="game__mainbutton-icon"></div></button>
                        : <button className="game__mainbutton" onClick={() => dispatch(getCodePopup())} >{lang.games2}</button>
            }
        </div>
    const simpleStyle = !(winners.length > 0 || (showGifts && Array.isArray(giftsList) && giftsList.length > 0))
    return (
        <>
            {
                shopStatus === 'active' && isSameTab === 1 && <GameShopSlider />
            }
            <div className={'game ' + (!simpleStyle ? 'bordered ' : '') + (isMobile ? 'mobile ' : '') + (simpleStyle ? 'simple' : '')} style={{ "borderRadius": borderStype }}>
                <div className='game__wheel'>
                    {
                        (canBeWonSomething)
                            ? <Wheel />
                            : <img className='game__empty_wheel' src={emptyWheel} alt='' />
                    }
                </div>
                {
                    isMobile && winners.length > 0 && mainButtonComponent
                }
                <div className="game__block">
                    <div className={'game__panel ' + (spinReady ? 'ready' : '')}>
                        <div className='game__panel_left'>
                            {showGifts &&
                                <div className='game__panel_button' onClick={() => dispatch(getGiftsListPopup())} >
                                    <div className='game__icon1'></div>
                                </div>
                            }
                        </div>
                        <div className='game__panel_center'>
                            <div className="game__title">
                                {lang.games3}
                            </div>
                            {winners.length >= 3 && <div className="game__subtitle">
                                {lang.games4}
                            </div>}
                        </div>
                        <div className='game__panel_right'>
                            {showWinners &&
                                <div className='game__panel_button' onClick={() => dispatch(getWinnersPopup())}>
                                    <div className='game__icon2'></div>
                                </div>
                            }
                        </div>
                    </div>
                    {
                        isMobile && winners.length === 0 && mainButtonComponent
                    }
                    {
                        winners.length >= 3 && <WinnersSlider className='games' winners={winners} showWinners={showWinners} getWinnersPopup={getWinnersPopup} />
                    }
                </div>

                <ShopWinnersPopup />
                <WheelWinnersPopup />
                <CodePopup />
                <GiftsListPopup />
            </div >
            {
                !isMobile && mainButtonComponent
            }
            {
                hasActiveGame && showLinkInGames && <div className="game__contacts" dangerouslySetInnerHTML={{ __html: '<p>' + lang.contacts + '</p>' }}>
                </div>
            }
        </>
    )
}